import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../react/components/Button';
import { useRemoveAllPerformancesSingleCyoMutation } from '../redux/tessituraApiSlice';
import Loader from '../../../../web/images/svg/loader.svg';

const CriticalError = ({ handleCloseModal, text, checkoutUrl }: CriticalErrorProps) => {
  const goToContactUs = () => window.location.pathname = 'contact-us'; // eslint-disable-line
  const textValue = text?.props?.children?.toString();

  const [removeAllPerformancesSingleCyo, {
    error: removePerformancesSingleCyoError,
    isLoading: removePerformancesSingleCyoIsLoading,
    isSuccess: removePerformancesSingleCyoIsSuccess,
  }] = useRemoveAllPerformancesSingleCyoMutation();

  useEffect(() => {
    if (removePerformancesSingleCyoIsSuccess) handleCloseModal();
  }, [handleCloseModal, removePerformancesSingleCyoIsSuccess]);

  const handleAcceptSingleCyo = async () => {
    try {
      await removeAllPerformancesSingleCyo(true);
    } catch ({ error }) {
      throw new Error(`Error removing performance: ${error}`);
    }
  };

  if (removePerformancesSingleCyoError) {
    return <div>Error: Could not remove performances</div>;
  }

  return (
    <div className="c-cyop__modal-buttons">
      {
        textValue?.includes('single performances')
          ? (
            <>
              <Button
                cyopModal
                onClick={handleAcceptSingleCyo}
                onKeyDown={handleAcceptSingleCyo}
                cyopModalWithLoader={removePerformancesSingleCyoIsLoading}
                disabled={removePerformancesSingleCyoIsLoading}
              >
                Clear Cart
                {(removePerformancesSingleCyoIsLoading) && (
                  <div className="c-loader c-loader--button c-loader--dark c-loader--small"><Loader /></div>
                )}
              </Button>

              <a
                className="c-button c-button--cyop-inverse c-button--cyop-modal"
                href={checkoutUrl}
              >
                Go To Checkout
              </a>
            </>
          )
          : (
            <>
              <Button
                cyopInverse
                cyopModal
                onClick={handleCloseModal}
                onKeyDown={handleCloseModal}
              >
                Go Back
              </Button>

              <Button
                cyopModal
                onClick={goToContactUs}
                onKeyDown={goToContactUs}
              >
                Go To Contact Us Page
              </Button>
            </>
          )
      }
    </div>
  );
};

CriticalError.defaultProps = {
  text: <></>,
};

const criticalErrorPropTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  checkoutUrl: PropTypes.string.isRequired,
  text: PropTypes.element,
};

CriticalError.propTypes = criticalErrorPropTypes;

type CriticalErrorProps = PropTypes.InferProps<typeof criticalErrorPropTypes>;

export default CriticalError;
